import { render, staticRenderFns } from "./dossierDetail.vue?vue&type=template&id=e2459f00&scoped=true"
import script from "./dossierDetail.vue?vue&type=script&lang=js"
export * from "./dossierDetail.vue?vue&type=script&lang=js"
import style0 from "./dossierDetail.vue?vue&type=style&index=0&id=e2459f00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2459f00",
  null
  
)

export default component.exports